import appInit from '@strangeanimals/common-vue-components/src/helpers/main';
import router from './helpers/router';
import config from './helpers/config';
import getCustomVuelidationConfig from "./helpers/vuelidationConfig";
const App = () => import('./App');

appInit(App,router,config,getCustomVuelidationConfig);
